<!-- 酒店详情 -->
<template>
    <div class='container'>
        <div class="divLine">
            <span>2020-06-20</span>&nbsp;入住&nbsp; <span>2020-06-23</span> &nbsp;离店 <span>&nbsp;3晚&nbsp;</span> &nbsp;<span>5个成人&nbsp;2个儿童</span>
        </div>
        <div class="divLine">
            <svg-icon style="margin-right: 0.05rem;" iconClass="time"></svg-icon> 3间 高级客房 Superior Room 双早 加个果盘
        </div>
        <div class="divLine">
            <svg-icon style="margin-right: 0.05rem;" iconClass="time"></svg-icon> 3间 普通客房 Superior Room 单早 希望可以靠窗比较一下Standard Room
        </div>
    </div>
</template>

<script>

export default {
    components: {},
    data() {
        return {

        }
    },
    computed: {},
    watch: {},
    methods: {

    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.container {
    .divLine {
        font-size: 0.15rem;
        color: #000;
        margin-bottom: 0.05rem;
        display: flex;
        align-items: center;
        span {
            font-weight: bold;
        }
    }
}
</style>